import { Box, Link } from '@mui/material';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useInterestList } from '../../../hooks/useInterest';

const MemberSwipe = () => {
  const { data } = useInterestList({ page: 1, limit: 10 });
  const interestList = data?.Data?.data || [];

  return (
    <Box sx={{ padding: '0 16px' }}>
      <Swiper
        className="member"
        spaceBetween={20}
        breakpoints={{
          100: { slidesPerView: 1 },
          767: { slidesPerView: 2 },
        }}
        modules={[Pagination]}
        pagination={{ clickable: true }}
        style={{ margin: '20px 0' }}
      >
        {interestList.map((item) => (
          <SwiperSlide key={item.index}>
            <Link href={item.external_url} target="_blank" sx={{ position: 'relative' }}>
              <Box
                component="img"
                src={item.image_url}
                alt="image"
                sx={{ width: '100%', maxWidth: '450px', display: 'block', margin: '0 auto' }}
              />
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default MemberSwipe;
